import { FC, ReactNode } from 'react';
import { useDrawerContext } from './DrawerContext';
import { IconButton, Stack, Typography } from '@mui/material';
import { KeyboardTabOutlined } from '@mui/icons-material';

type Props = Readonly<{
	title?: string | ReactNode;
	menu?: ReactNode;
}>;

export const DrawerHeader: FC<Props> = ({ title, menu }) => {
	const { closeDrawer } = useDrawerContext();

	return (
		<Stack justifyContent={'space-between'} display={'flex'} width={'100%'} flexDirection={'row'} alignItems={'center'} flexWrap={'nowrap'}>
			<Typography
				variant={'h3'}
				fontWeight={700}
				sx={{
					display: '-webkit-box',
					overflow: 'hidden',
					WebkitBoxOrient: 'vertical',
					WebkitLineClamp: 2,
				}}
			>
				{title}
			</Typography>
			<Stack direction={'row'} alignItems={'center'} gap={1}>
				{menu}
				<IconButton onClick={() => closeDrawer()}>
					<KeyboardTabOutlined />
				</IconButton>
			</Stack>
		</Stack>
	);
};
